import { useProviderDetailStore } from "../../store/provider-details/providerDetailStore";

import ProviderAdditionalContactsDisplayView from "./ProviderAddionalContactsDisplayView";

export default function ProviderAdditionalEmailsDisplayView({ data }) {
  const { additionalEmailTypes } = useProviderDetailStore();

  return (
    <ProviderAdditionalContactsDisplayView
      dataMap={data?.emails ?? {}}
      typesMap={additionalEmailTypes}
      valueKey="email"
      typeKey="emailType"
      labelSuffix="Email"
    />
  );
}
